import { ApplicationRoutes } from '../../../app-routes-names'

export const InfoRoutes = {
  whoToCall: 'who-to-call',
  publicResources: 'public-resources'
}

const { info } = ApplicationRoutes

export const InfoPaths = {
  whoToCall: `/${info}/${InfoRoutes.whoToCall}`,
  publicResources: `/${info}/${InfoRoutes.publicResources}`
}
